var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSelect',_vm._g(_vm._b({attrs:{"items":_vm.roles,"item-text":"display_name","item-value":"id","hide-details":"auto","multiple":!_vm.single}},'VSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }